import { Badge } from '@shopify/polaris';
import type { ConnectionStatus } from '../types';

// R11: All six `ConnectionStatus` states must be rendered. The issue body
// undercounts at four; the canonical list lives in `../types.ts`.

type Tone = 'success' | 'critical' | 'warning' | 'info';

const TONE: Record<ConnectionStatus, Tone> = {
  active: 'success',
  testing: 'info',
  error: 'critical',
  disabled: 'info',
  pending_install: 'warning',
  uninstalled: 'critical',
};

const LABEL: Record<ConnectionStatus, string> = {
  active: 'Active',
  testing: 'Testing',
  error: 'Error',
  disabled: 'Disabled',
  pending_install: 'Install pending',
  uninstalled: 'Uninstalled',
};

export function StatusBadge({ status }: { status: ConnectionStatus }) {
  return <Badge tone={TONE[status]}>{LABEL[status]}</Badge>;
}
